import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../models/api';
import { environment } from 'src/environments/environment';
import { CommonMethods } from '../common-methods';

@Injectable({
    providedIn: 'root'
})

export class UserService {
    constructor(
        private http: HttpClient
    ) { }

    //To take Business URL
    userUrl: string = '';
    role: string | null = CommonMethods.getItem("role");

    /**
     * To set URL
     * Service loads only once, so when business changes, it does not load again
     * BusinessId stays the same and creates authentication problem
     * This function needs to be called each time before API call.
     */
    private __init() {
        this.userUrl = ''
        const userId = CommonMethods.getItem("userId");
        const companyId = CommonMethods.getItem("companyId");
        if (this.role == 'ADMIN' || this.role == 'COMPANY') {
            if (this.role == 'ADMIN') {
                this.userUrl = `${environment.API_BASE_URL}/superAdmin/${userId}`
            }
            else {
                this.userUrl = `${environment.API_BASE_URL}/company/${userId}`;
            }
        }
        else {
            this.userUrl = `${environment.API_BASE_URL}/company/${companyId}/employee/${userId}`
        }
        return this;
    }

    /**
     * to get the user/s from API
     * all the users are taken for user page
     * @returns http status
     */
    public getUser(): Observable<ApiResponse<any>> {
        return this.__init().http
            .get<ApiResponse<any>>(this.userUrl)
    }
}
